/* Delfino — peretele de recenzii: coloane „masonry”, „Arată mai multe recenzii”, „Citește tot”.
   - scope pe un singur [data-dl-reviews] (secțiunea se poate repeta / reîncărca în editor);
   - bind idempotent (dataset.bound) și înregistrare prin DL.use, cu rezervă pe DOMContentLoaded
     (scriptul e `defer` în markup-ul secțiunii și rulează ÎNAINTE de theme.js);
   - așezare: fiecare card vizibil intră în coloana cea mai scurtă; la „Arată mai multe” cardurile
     noi se adaugă la fel, deci cele deja citite nu se mai mișcă. La schimbarea numărului de coloane
     (rotire, redimensionare) peretele se reconstruiește în ordinea inițială;
   - fără JS rămân coloanele CSS cu toate cardurile la vedere (vezi <noscript> din secțiune).
   Nicio cerere de rețea — totul e DOM local. */
(function () {
  'use strict';

  /** Câte coloane are peretele la o lățime de fereastră dată (aceleași praguri ca în CSS). */
  function columnsFor(width) {
    if (width >= 1100) return 4;
    if (width >= 700) return 2;
    return 1;
  }

  /** Indexul coloanei celei mai scurte; la egalitate câștigă cea din stânga. */
  function shortestIndex(heights) {
    var best = 0;
    for (var i = 1; i < heights.length; i++) if (heights[i] < heights[best]) best = i;
    return best;
  }

  /** Textul citit de cititoarele de ecran după fiecare dezvăluire. */
  function statusText(shown, total) {
    return 'Se afișează ' + shown + ' din ' + total + ' recenzii.';
  }

  function initReviewsWall(section) {
    section.dataset.bound = '1';
    var wrap = section.querySelector('[data-dl-rev-wrap]');
    var wall = section.querySelector('[data-dl-rev-wall]');
    if (!wrap || !wall) return;
    var cards = Array.prototype.slice.call(wall.querySelectorAll('[data-dl-rev-card]'));
    var moreBtn = section.querySelector('[data-dl-rev-more]');
    var status = section.querySelector('[data-dl-rev-status]');
    var step = parseInt(section.getAttribute('data-step'), 10) || 8;
    var cols = [];
    var colCount = 0;
    var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function isShown(card) { return !card.classList.contains('is-extra'); }

    /* Pe telefon (o coloană) Liquid + CSS pornesc cu jumătate din carduri (`is-extra-phone`).
       Preluăm o singură dată starea în clasele „normale”, ca restul logicii să fie una singură. */
    var phoneStart = columnsFor(window.innerWidth || document.documentElement.clientWidth || 0) === 1;
    cards.forEach(function (c) {
      if (phoneStart && c.classList.contains('is-extra-phone')) c.classList.add('is-extra');
      c.classList.remove('is-extra-phone');
    });
    if (cards.some(function (c) { return !isShown(c); })) wrap.classList.add('is-collapsed');
    wrap.classList.remove('is-collapsed-phone');

    /* „Citește tot” apare doar dacă textul chiar e tăiat de trunchierea pe 7 rânduri. */
    function checkClamp(card) {
      var text = card.querySelector('[data-dl-rev-text]');
      var btn = card.querySelector('[data-dl-rev-expand]');
      if (!text || !btn) return;
      if (text.classList.contains('is-open')) { btn.hidden = false; return; }
      btn.hidden = !(text.scrollHeight > text.clientHeight + 2);
    }

    function place(card) {
      var heights = cols.map(function (c) { return c.offsetHeight; });
      cols[shortestIndex(heights)].appendChild(card);
      checkClamp(card);
    }

    function build() {
      var n = columnsFor(window.innerWidth || document.documentElement.clientWidth || 0);
      if (n === colCount) { cards.filter(isShown).forEach(checkClamp); return; }
      colCount = n;
      var stash = document.createDocumentFragment();
      cards.forEach(function (c) { stash.appendChild(c); });
      wall.innerHTML = '';
      wall.classList.add('is-js');
      cols = [];
      for (var i = 0; i < n; i++) {
        var col = document.createElement('div');
        col.className = 'dl-rev-col';
        wall.appendChild(col);
        cols.push(col);
      }
      cards.forEach(function (c) { if (isShown(c)) place(c); });
      /* cardurile încă ascunse rămân în perete, după coloane (display:none din CSS) */
      cards.forEach(function (c) { if (!isShown(c)) wall.appendChild(c); });
    }

    function finish() {
      wrap.classList.remove('is-collapsed');
    }

    function reveal(list, focusFirst) {
      list.forEach(function (c) {
        c.classList.remove('is-extra');
        if (!reduced) c.classList.add('is-new');
        place(c);
      });
      var shown = cards.filter(isShown).length;
      if (shown >= cards.length) finish();
      if (status) status.textContent = statusText(shown, cards.length);
      if (focusFirst && list[0]) {
        list[0].setAttribute('tabindex', '-1');
        try { list[0].focus({ preventScroll: true }); } catch (e) { list[0].focus(); }
      }
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var hidden = cards.filter(function (c) { return !isShown(c); });
        reveal(hidden.slice(0, colCount === 1 ? Math.ceil(step / 2) : step), true);
      });
    }

    section.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-dl-rev-expand]') : null;
      if (!btn || !section.contains(btn)) return;
      var card = btn.closest('[data-dl-rev-card]');
      var text = card && card.querySelector('[data-dl-rev-text]');
      if (!text) return;
      var open = !text.classList.contains('is-open');
      text.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Restrânge' : 'Citește tot';
    });

    /* Editorul de teme: blocul selectat trebuie să fie vizibil, chiar dacă e printre cele ascunse. */
    section.addEventListener('shopify:block:select', function (e) {
      var card = e.target && e.target.closest ? e.target.closest('[data-dl-rev-card]') : null;
      if (!card || isShown(card)) return;
      var upTo = cards.indexOf(card);
      reveal(cards.filter(function (c, i) { return i <= upTo && !isShown(c); }), false);
    });

    var timer = null;
    window.addEventListener('resize', function () {
      if (!document.body.contains(section)) return;
      clearTimeout(timer);
      timer = setTimeout(build, 150);
    });

    build();
    /* fonturile/lățimile finale pot schimba înălțimile: mai verificăm o dată trunchierea */
    window.addEventListener('load', function () { cards.filter(isShown).forEach(checkClamp); });
  }

  function register(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = Array.prototype.slice.call(scope.querySelectorAll('[data-dl-reviews]'));
    if (scope !== document && scope.matches && scope.matches('[data-dl-reviews]')) list.push(scope);
    list.forEach(function (section) {
      if (section.dataset.bound) return;
      initReviewsWall(section);
    });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { columnsFor: columnsFor, shortestIndex: shortestIndex, statusText: statusText };
    return;
  }

  if (window.DL && typeof window.DL.use === 'function') {
    window.DL.use(register);
    if (document.readyState !== 'loading') register(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      if (window.DL && typeof window.DL.use === 'function') window.DL.use(register);
      register(document);
    });
  }
})();
